fx.ns("shared", class Behaviour extends fx.EventDispatcher{

    constructor(mouse, type, model)
    {
        super(); 

        this._active = false;

        this._mouse = mouse;
        this._type = type;

        this._enabled = false;

        this.precision = model.creation.extraScale * fx.get("settings").precision;

        this.enable();
    }
    

    _event(event)
    {
        if (event.disabled || (event.state != "end" && event.element && !event.element.editable))
            return;
            
        if (event.state == "start")
            this.start(event);
        else
        if (event.state == "action")
            this.action(event);
        else
        if (event.state == "end")
            this.end(event);
    }

    get mouse()
    {
        return this._mouse;
    }

    get active()
    {
        return this._active;
    }

    enable(){
        if (this._enabled)
            return;

        this.on(this._type, this._event, this._mouse);
        
        this._enabled = true;
    }

    disable(){
        if (!this._enabled)
            return;

        this.off(this._type, this._event, this._mouse);
        
        this._enabled = false;
    }


    start(event){
        this._active = true;
    }

    action(event){

    }

    end(event){
        this._active = false;
    }

    avoidLostBorderCoordinates(left, top, rotation, width, height, area, element, resize)
    {
        if (!area)
        area = this.area;

        if (!element)
            element = this.element;  

        if (!area || !element)
            return {left : left, top : top, angle : rotation};

        width = width ? width : element.width;
        height = height ? height : element.height;
            
        let insideBox = {   
            left : area.lostBorder, 
            top : area.lostBorder,
            right : area.realWidth - area.lostBorder,
            bottom : area.realHeight - area.lostBorder 
        }; 
        
        let rect = fx.graphics.getBoundingRect({x : left, y : top, width : width, height : height}, rotation);
        let angle = rotation > 360 ? rotation - 360 : rotation;
        let topCorrected = false, leftCorrected = false;
        let newLeft, newTop, newWidth = width, newHeight = height;

        if (Math.round(rect.x) <= Math.round(insideBox.left)*1.5 && Math.round(rect.x) > area.lostBorder/2)
        {
            if (angle >= 270 && angle <= 360)
                newLeft = 0;
            else
            if (angle >= 0 && angle < 90)
                newLeft = 0 + Math.cos(this.toRadian(90 - angle)) * height;
            else
            if (angle >= 90 && angle < 180)
                newLeft = 0 + (Math.sin( this.toRadian(angle-90))  * width) + (Math.cos( this.toRadian(angle- 90) ) * height);
            else
            if (angle >= 180 && angle < 270)
                newLeft = 0 + (Math.cos( this.toRadian(angle-180))  * width);

            newWidth += Math.abs(left - newLeft);
            left = newLeft;
                
            leftCorrected = true;
        }

        if (Math.round(rect.y) <= Math.round(insideBox.top)*1.5 && Math.round(rect.y) > area.lostBorder/2)
        {
            if (angle >= 270 && angle <= 360)
                newTop = 0 + Math.cos( this.toRadian(angle - 270) ) * width;
            else
            if (angle >= 0 && angle < 90)
                newTop = 0;
            else
            if (angle >= 90 && angle < 180)
                newTop = 0 + Math.sin( this.toRadian( angle - 90)) * height;
            else
            if (angle >= 180 && angle < 270)
                newTop = 0 + Math.sin( this.toRadian( angle - 180) ) * width + Math.cos( this.toRadian(angle - 180) ) * height;
            
            newHeight += Math.abs(top - newTop);
            top = newTop;
                      
            topCorrected = true;
        }

        if (Math.round(rect.x + rect.width) >= (Math.round(insideBox.right) - area.lostBorder/2) && Math.round(rect.x + rect.width) < (Math.round(insideBox.right) + area.lostBorder/2))
        {
            if (angle >= 270 && angle <= 360)
                newLeft = area.realWidth - rect.width;
            else
            if (angle >= 0 && angle < 90)
                newLeft = area.realWidth - Math.sin( this.toRadian( 90 - angle)) * width;
            else
            if (angle >= 90 && angle <= 180)
                newLeft = area.realWidth;
            else
            if (angle > 180 && angle < 270)
                newLeft = area.realWidth - Math.sin(this.toRadian(angle - 180)) * height;

            newWidth += Math.abs(left - newLeft);
            if (!resize)
                left = newLeft;

            leftCorrected = true;
        }

        if (Math.round(rect.y + rect.height) >= (Math.round(insideBox.bottom) - area.lostBorder/2) && Math.round(rect.y + rect.height) < (Math.round(insideBox.bottom) + area.lostBorder/2))
        {
            if (angle >= 270 && angle <= 360)
                newTop = area.realHeight - Math.cos(this.toRadian( 360 - angle)) * height;
            else
            if (angle >= 0 && angle < 90)
                newTop = area.realHeight - rect.height;
            else
            if (angle >= 90 && angle < 180)
                newTop = area.realHeight - Math.cos(this.toRadian( angle - 90)) * width;
            else
            if (angle >= 180 && angle < 270)
                newTop = area.realHeight;

            newHeight += Math.abs(top - newTop);
            if (!resize)
                top = newTop;

            topCorrected = true;
        }
       
        if (!topCorrected)
            top = top.multipleOf( this.precision );
        
        if (!leftCorrected)
            left = left.multipleOf( this.precision );
        
        return {left : left, top : top, angle : rotation, width : newWidth, height : newHeight};
    }

    lockOnLostBorderCoordinates(left, top, rotation, width, height, area, element)
    {
        if (!area)
            area = this.area;

        if (!element)
            element = this.element;

        if (!area || !element)
            return {left : left, top : top, angle : rotation};

        width = width ? width : element.width;
        height = height ? height : element.height;
            
        let insideBox = {   
            left : area.lostBorder + (area.hasClass("right") ? area.realWidth : 0 ), 
            top : area.lostBorder,
            right : area.realWidth - area.lostBorder + (area.hasClass("right") ? area.realWidth  - 2*area.lostBorder : 0 ),
            bottom : area.realHeight - area.lostBorder 
        }; 
        
        let rect = fx.graphics.getBoundingRect({x : left, y : top, width : width, height : height}, rotation);
        let angle = rotation > 360 ? rotation - 360 : rotation;
        let corrected = false, sides = 0;
        
        if (rect.x < insideBox.left)
        {
            if (angle >= 270 && angle <= 360)
                left = insideBox.left;
            else
            if (angle >= 0 && angle < 90)
                left = insideBox.left + Math.cos(this.toRadian(90 - angle)) * height;
            else
            if (angle >= 90 && angle < 180)
                left = insideBox.left + (Math.sin( this.toRadian(angle-90))  * width) + (Math.cos( this.toRadian(angle- 90) ) * height);
            else
            if (angle >= 180 && angle < 270)
                left = insideBox.left + (Math.cos( this.toRadian(angle-180))  * width);

            corrected = true;
            sides++;
        }
        

        if (rect.y < insideBox.top)
        {
            if (angle >= 270 && angle <= 360)
                top = insideBox.top + Math.cos( this.toRadian(angle - 270) ) * width;
            else
            if (angle >= 0 && angle < 90)
                top = insideBox.top;
            else
            if (angle >= 90 && angle < 180)
                top = insideBox.top + Math.sin( this.toRadian( angle - 90)) * height;
            else
            if (angle >= 180 && angle < 270)
                top = insideBox.top + Math.sin( this.toRadian( angle - 180) ) * width + Math.cos( this.toRadian(angle - 180) ) * height;

            corrected = true;
            sides++;
        }

        if (rect.x + rect.width > insideBox.right)
        {
            if (angle >= 270 && angle <= 360)
                left = insideBox.right - rect.width;
            else
            if (angle >= 0 && angle < 90)
                left = insideBox.right - Math.sin( this.toRadian( 90 - angle)) * width;
            else
            if (angle >= 90 && angle <= 180)
                left = insideBox.right;
            else
            if (angle > 180 && angle < 270)
                left = insideBox.right - Math.sin(this.toRadian(angle - 180)) * height;

            corrected = true;
            sides++;
        }

        if (rect.y + rect.height > insideBox.bottom)
        {
            if (angle >= 270 && angle <= 360)
                top = insideBox.bottom - Math.cos(this.toRadian( 360 - angle)) * height;
            else
            if (angle >= 0 && angle < 90)
                top = insideBox.bottom - rect.height;
            else
            if (angle >= 90 && angle < 180)
                top = insideBox.bottom - Math.cos(this.toRadian( angle - 90)) * width;
            else
            if (angle >= 180 && angle < 270)
                top = insideBox.bottom;

            corrected = true;
            sides++;
        }

        return {left : left, top : top, angle : rotation, corrected : corrected, sides : sides};
    }

    toRadian(angle)
    {
        return Number(angle) * Math.PI / 180;
    }

    lockScreen(event, lock)
    {
        if (lock)
        {
            fx.dom.addClass(fx.dom.find(".ScrollableContent"), "locked-scroll");
            fx.dom.addClass(fx.dom.find(".Scrollable"), "locked-scroll");
            fx.dom.addClass(fx.dom.find("body"), "locked-scroll");

            if (event.cancelable)
            {
                event.preventDefault();
                event.stopPropagation();
            }
        }
        else
        {
            fx.dom.removeClass(fx.dom.find(".ScrollableContent"), "locked-scroll");
            fx.dom.removeClass(fx.dom.find(".Scrollable"), "locked-scroll");
            fx.dom.removeClass(fx.dom.find("body"), "locked-scroll");

            if (event.cancelable)
            {
                event.preventDefault();
                event.stopPropagation();
            }
        }
    }
});